/**
 * CreateBuildList — "All games" build view (specs/challenge-flow-redesign — Story 3).
 * Reuses the existing date calendar + league-grouped games list. Shares the same picks
 * as the deck (both read/write pickSlips), so switching views never diverges the slate.
 */

import React, { useMemo } from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import { CreateCalendarHeader } from '../CreateCalendarHeader/CreateCalendarHeader';
import { CreateGamesStep } from '../CreateGamesStep/CreateGamesStep';
import { useCreatePage } from '../../../src/create/contexts/CreatePageContext';
import { CREATE_FLOW_TEST_IDS } from '../../../src/create/constants/create.constants';

const styles = StyleSheet.create({
  container: { flex: 1, minHeight: 0 },
  scroll: { flex: 1 },
  scrollContent: { paddingHorizontal: 16, paddingBottom: 16 },
});

export const CreateBuildList: React.FC = () => {
  const { scrollViewRef } = useCreatePage();
  const contentStyle = useMemo(() => styles.scrollContent, []);

  return (
    <View style={styles.container} testID={CREATE_FLOW_TEST_IDS.list}>
      <CreateCalendarHeader />
      <ScrollView
        ref={scrollViewRef}
        style={styles.scroll}
        contentContainerStyle={contentStyle}
        showsVerticalScrollIndicator={false}
      >
        <CreateGamesStep />
      </ScrollView>
    </View>
  );
};
